import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { CAMPAIGN } from "@/config/campaign";
import { ChickenAvatar } from "@/components/Mascot";
import { Wordmark } from "@/components/Header";

export const Footer = () => (
  <footer className="bg-ink py-12" data-testid="footer">
    <div className="mx-auto flex max-w-[1180px] flex-col gap-8 px-5 md:flex-row md:items-start md:justify-between">
      <div>
        <div className="flex items-center gap-2.5">
          <ChickenAvatar className="h-7 w-7" />
          <Wordmark dark />
        </div>
        <a
          data-testid="footer-instagram-link"
          href={CAMPAIGN.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex items-center gap-2 text-sm text-offwhite/60 transition-colors duration-200 hover:text-gold"
        >
          <Instagram className="h-4 w-4" strokeWidth={1.5} /> {CAMPAIGN.instagramHandle}
        </a>
      </div>
      <nav className="flex flex-col gap-3 text-sm" aria-label="Rechtliches">
        <Link data-testid="footer-teilnahmebedingungen-link" to="/teilnahmebedingungen" className="text-offwhite/60 transition-colors duration-200 hover:text-gold">Teilnahmebedingungen</Link>
        <Link data-testid="footer-datenschutz-link" to="/datenschutz" className="text-offwhite/60 transition-colors duration-200 hover:text-gold">Datenschutz</Link>
        <Link data-testid="footer-impressum-link" to="/impressum" className="text-offwhite/60 transition-colors duration-200 hover:text-gold">Impressum</Link>
        <a data-testid="footer-kontakt-link" href={`mailto:${CAMPAIGN.contactEmail}`} className="inline-flex items-center gap-2 text-offwhite/60 transition-colors duration-200 hover:text-gold">
          <Mail className="h-4 w-4" strokeWidth={1.5} /> {CAMPAIGN.contactEmail}
        </a>
      </nav>
    </div>
    <div className="mx-auto mt-10 max-w-[1180px] px-5">
      <p className="text-xs text-offwhite/40">© 2026 ChickenWinner.ch</p>
    </div>
  </footer>
);
